import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";
import logo from "../assets/kemarilogohero.png";

const EyeOpenIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 5C7 5 2.73 8.11 1 12.5 2.73 16.89 7 20 12 20s9.27-3.11 11-7.5C21.27 8.11 17 5 12 5z"
      stroke="#8e8e93" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    />
    <circle cx="12" cy="12.5" r="3" stroke="#8e8e93" strokeWidth="1.5" />
  </svg>
);

const EyeClosedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 3l18 18M10.58 10.59A3 3 0 0014.99 15M6.36 6.37C4.51 7.69 3.07 9.46 2 11.5 3.73 15.89 8 19 13 19c1.7 0 3.31-.43 4.73-1.18M9.9 5.08C10.59 4.9 11.29 4.8 12 4.8c5 0 9.27 3.11 11 7.5-.57 1.39-1.4 2.63-2.41 3.67"
      stroke="#8e8e93" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    />
  </svg>
);

function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("https://api.kemari-corp.com/admin_login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

      if (data.admin) {
        localStorage.setItem("admin", JSON.stringify(data.admin));
        navigate("/admin/dashboard", { replace: true });
      } else {
        setError(data.message || "Invalid credentials");
      }
    } catch (err) {
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="al-page">
      <div className="al-card">

        {/* Logo */}
        <div className="al-logo-wrap">
          <img src={logo} alt="Kemari" className="al-logo" />
        </div>

        {/* Headings */}
        <h1 className="al-heading">Welcome back</h1>
        <p className="al-subheading">Sign in to your admin account</p>

        {/* Input Group */}
        <form className="al-field-group" onSubmit={handleLogin}>
          {/* Username */}
          <div className="al-field">
            <label className="al-label" htmlFor="username">Username</label>
            <input
              id="username"
              className="al-input"
              type="text"
              value={username}
              required
              autoComplete="username"
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          {/* Password */}
          <div className="al-field-last">
            <label className="al-label" htmlFor="password">Password</label>
            <input
              id="password"
              className="al-input al-input--password"
              type={showPassword ? "text" : "password"}
              value={password}
              required
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="al-eye-btn"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
            </button>
          </div>
        </form>

        {/* Error */}
        {error && <p className="al-error">{error}</p>}

        {/* Submit */}
        <button
          className="al-submit"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>

        {/* Footer */}
        <div className="al-divider" />
        <p className="al-footer">Kemari Admin Portal &nbsp;·&nbsp; Restricted Access</p>

      </div>
    </div>
  );
}

export default AdminLogin;